import dayjs from 'dayjs'
import { makeAutoObservable, runInAction } from 'mobx'
import { toast } from 'react-toastify'
import { store } from './store'
import { AuthorizedModInterface } from '../models/User'

export default class MethodsStore {
  showCreateAuction = false

  showEditAuction = false

  showCreatePost = false

  showEditPost = false

  showDelete = false

  reviewAuction = false

  hasAuctionFinished = false

  selectedCurrency = 'CHF'

  currencyCodes = ['CHF', 'EUR', 'USD']

  constructor() {
    makeAutoObservable(this)
  }

  setShowCreateAuction = (state: boolean) => {
    if (!store.userStore.isLoggedIn) {
      return toast.error('Please Log in')
    }
    if (store.userStore.user!.auctionUse! < 1) {
      return toast.error('No available auctions uses.')
    }
    this.showCreateAuction = state
  }

  openShowEditAuction = () => {
    store.auctionStore.setAuctionEdit()
    runInAction(() => {
      this.showEditAuction = true
    })
  }

  closeShowEditAuction = () => {
    this.showEditAuction = false
  }

  setShowCreatePost = (state: boolean) => {
    if (!store.userStore.isLoggedIn) {
      return toast.error('Please Log in')
    }
    this.showCreatePost = state
  }

  openShowEditPost = () => {
    const selectedPost = store.postListStore.postDetails
    if (selectedPost) {
      store.postStore.selectPosts(selectedPost)
      runInAction(() => {
        this.showEditPost = true
      })
    }
  }

  closeShowEditPost = () => {
    this.showEditPost = false
  }

  setShowDelete = (state: boolean) => {
    this.showDelete = state
  }

  setReviewAuction = (state: boolean) => {
    this.reviewAuction = state
  }

  setHasAuctionFinished = (state: boolean) => {
    this.hasAuctionFinished = state
  }

  formatDateLocal = (date: Date) => dayjs.utc(date).local().format('YYYY-MM-DDTHH:mm:ss')

  formatDateUtc = (date: Date) => dayjs.utc(date).format('YYYY-MM-DDTHH:mm:ss')

  isAuctionCreator = () => store.bidsStore.auctionDetails?.post?.userId === store.userStore.user?.id

  isPostCreator = () => {
    const isCreator = store.postListStore.postDetails?.userId === store.userStore.user?.id
    return isCreator
  }

  isAuctionFinished = () => new Date() > new Date(store.bidsStore.auctionDetails?.deadline as Date)

  canReviewAuction = () => {
    const userId = store.bidsStore.auctionDetails?.post?.userId
    const currentUserId = store.userStore.user?.id
    return (
      (userId === currentUserId && currentUserId) ||
      (store.bidsStore.auctionDetails?.authorizedMods &&
        store.bidsStore.auctionDetails.authorizedMods.some(
          (mod) =>
            (mod as AuthorizedModInterface).user.id === currentUserId &&
            (mod as AuthorizedModInterface).roles?.includes('Moderator'),
        ))
    )
  }
}
